module.exports = __webpack_public_path__ + "static/tools-631bf2df9856c5329bfa9bf7c2ba45c7.png";